import { Component, Input, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

@Component({
  selector: "app-bulk-dialog-grid",
  templateUrl: "./bulk-dialog-grid.component.html",
  styleUrls: ["./bulk-dialog-grid.component.scss"],
})
export class BulkDialogGridComponent implements OnDestroy {
  @Input() gridOptions;
  private _rowData: any[];
  get rowData() {
    return this._rowData;
  }
  private destroy$ = new Subject<void>();
  @Input() set rowData(rowData: any[]) {
    this._rowData = rowData;
  }

  constructor() {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
